import React, { useEffect } from 'react';
import './App.css';
import Routes from './Routes';
import history from './history';
import CustomRouter from './CustomRouter';
import { initialGoogleAnalytics } from './helpers/ga-helpers';
//TODO uncomment when ready for release
// import { setLocalStorage , removeLocalStorage } from './utils';
// import { APP_SOURCE, APP_SOURCE_TYPES } from './data/local-storage-constants';
// import { EVENT_LISTENERS , LOCALSTORAGE_KEYS } from './data/constants';
// import {sendEventRequest} from './helpers/common-helper';
// const handleMessage = (e: MessageEvent) => {
//   try {
//     const data = (e.data as any)?.detail;
//     if (!data) return;

//     if (data.key === EVENT_LISTENERS.RESPONSE_VERSION_REQUEST) {
//       const nwAppVersion = data.message?.nwAppVersion || "";
//       const oracleVersion = data.message?.oracleVersion || "";

//       console.log("iframe received versions:", {
//         nwAppVersion,
//         oracleVersion,
//       });

//       setLocalStorage(LOCALSTORAGE_KEYS.NW_APP_VERSION, nwAppVersion);
//       setLocalStorage(LOCALSTORAGE_KEYS.ORACLE_VERSION, oracleVersion);
//     }
//   } catch (error) {
//     console.error("Error handling message event:", error);
//   }
// };
const App = (): React.JSX.Element => {
  // useEffect(() => {
  //   removeLocalStorage(LOCALSTORAGE_KEYS.NW_APP_VERSION);
  //   removeLocalStorage(LOCALSTORAGE_KEYS.ORACLE_VERSION);
  //   try {
  //     window.addEventListener("message", handleMessage);
  //     sendEventRequest(EVENT_LISTENERS.GET_VERSION_REQUEST);
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   return () => window.removeEventListener("message", handleMessage);
  // }, []);

  initialGoogleAnalytics();

  return (
    <div>
      <CustomRouter history={history}>
        <Routes />
      </CustomRouter>
    </div>
  );
}

export default App;
